import XLSX from 'xlsx';
import { fileToArrayBuffer, uploadFile } from '@/utils/bulkUpload';

const SHEET_IMPORT_DATA_NAME = 'IMPORT-DATA';
const SHEET_PROTECTION = 'PLANT-IMPORT';
const SHEET_PLANT_IMPORT_NAME = 'PLANT-IMPORT';
const SHEET_IMPORT_CONFIG_NAME = 'IMPORT-CONFIG';
export const DEFAULT_SHEET_COLUMNS = ['custom_id', 'title', 'custom_revision'];
export const DEFAULT_FILE_NAME_TEMPLATE = 'import-template.xlsx';
export const DEFAULT_BULK_FILE_NAME = 'bulk-upload.xlsx';
export const APP_XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function downloadSpreadSheetTemplate(columns, config, fileName) {
	let book = XLSX.utils.book_new();

	const workSheet_import_data = XLSX.utils.aoa_to_sheet([columns]);
	XLSX.utils.book_append_sheet(book, workSheet_import_data, SHEET_IMPORT_DATA_NAME);

	const workSheet_import_config = XLSX.utils.json_to_sheet([config]);
	workSheet_import_config['!protect'] = { password: SHEET_PROTECTION };
	XLSX.utils.book_append_sheet(book, workSheet_import_config, SHEET_IMPORT_CONFIG_NAME);

	XLSX.writeFile(book, fileName);
}

export function downloadFileTemplate(contents) {
	const book = XLSX.utils.book_new();
	const export_table = contents.map(content => {
		const { filename, custom_id, custom_revision, title } = content;
		return { filename, custom_id, custom_revision, title };
	});

	const workSheet = XLSX.utils.json_to_sheet(export_table);
	XLSX.utils.book_append_sheet(book, workSheet, SHEET_PLANT_IMPORT_NAME);
	XLSX.writeFile(book, DEFAULT_BULK_FILE_NAME);
}

export async function uploadFileSpreadSheet(contents) {
	const file_buffer = await uploadFile();
	const book = XLSX.read(file_buffer, { type: 'array' });
	const workSheet = book.Sheets[SHEET_PLANT_IMPORT_NAME];
	const sheetChanges = XLSX.utils.sheet_to_json(workSheet);

	for (const change of sheetChanges) {
		const { filename } = change;
		const content = contents.find(content => content.filename === filename);

		if (change.custom_id) change.custom_id = change.custom_id + '';
		if (change.title) change.title = change.title + '';
		if (content) Object.assign(content, change);
	}
}

export async function getSpreadsheetData(file) {
	const file_buffer = await fileToArrayBuffer(file);
	const book = XLSX.read(file_buffer, { type: 'array' });
	const import_data = XLSX.utils.sheet_to_json(book.Sheets[SHEET_IMPORT_DATA_NAME]);
	const import_config = XLSX.utils.sheet_to_json(book.Sheets[SHEET_IMPORT_CONFIG_NAME])[0];

	return { import_data, import_config };
}
